import { NAME } from "./constants";

export const SET_CONTENT_LOADING = `${NAME}/SET_CONTENT_LOADING`;

export const SET_CONTENT_RESPONSE = `${NAME}/SET_CONTENT_RESPONSE`;